<template>
  <div class="page-404">
    <v-parallax
      class="section-hero"
      :src="require(`@/assets/hero-${networkName}.jpg`)"
      :lazy-src="require(`@/assets/hero-${networkName}-min.jpg`)"
    >
      <v-container>
        <div class="hero-container">
          <v-row align="center" justify="center">
            <v-col cols="12" md="7" sm="auto" class="text-center">
              <h1 class="display-4 font-weight-bold mb-2">Oops!</h1>
              <p class="subtitle-1 grey--text mb-6">
                We can't seem to find the page you're looking for.
              </p>

              <v-btn tile link to="/">
                <v-icon left>mdi-arrow-left</v-icon>
                Go to home
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-parallax>
    <v-container class="recent-bans">
      <section class="content"></section>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "PageNotFound",

  data: () => ({
    //
  })
};
</script>
